import { Briefcase, ArrowRightLeft, Hammer, Calculator, Library, Users, type LucideIcon } from 'lucide-react';

export const ALLOWED_ICONS = ['briefcase', 'arrow-right-left', 'hammer', 'calculator', 'library', 'users'] as const;

export const ICON_MAP: Record<string, LucideIcon> = {
  'briefcase': Briefcase,
  'arrow-right-left': ArrowRightLeft,
  'hammer': Hammer,
  'calculator': Calculator,
  'library': Library,
  'users': Users,
};

export function getModuleIcon(iconName: string): LucideIcon {
  const icon = ICON_MAP[iconName];
  if (!icon) {
    console.warn(`[moduleIcons] Unknown icon: "${iconName}". Falling back to Briefcase. Allowed: ${ALLOWED_ICONS.join(', ')}`);
    return Briefcase;
  }
  return icon;
}
